// @flow strict

import * as React from 'react';
import { Link } from '../../internal/Button';
import { QuoteBase } from '../Quote';
import PageContentBlock from '../../internal/PageContentBlock';
import ResponsiveImage from '../../internal/ResponsiveImage';
import styles from './styles.scss';

type PropTypes = {|
  logo: string,
  name: string,
  industry?: string,
  field?: string,
  advisor?: string,
  pdfLink?: string,

  quote: string,
  author?: string,
  authorTitle?: string,
  authorCompany?: string,
|};

export default (props: PropTypes) => {
  const descriptions = {
    Industry: props.industry,
    Field: props.field,
    Advisor: props.advisor,
  };

  return (
    <PageContentBlock layout="Thin">
      <div>
        <div className={styles.logoContainer}>
          <ResponsiveImage
            className={styles.logo}
            src={props.logo}
            alt={`${props.name} logo`}
            defaultSize={{ width: 200, height: 70 }}
          />
          {props.pdfLink && (
            <Link href={props.pdfLink} className={styles.button}>
              Download case study
            </Link>
          )}
        </div>
        {(props.advisor || props.field || props.industry) && (
          <dl>
            {Object.entries(descriptions)
              .filter(([, description]) => description)
              .map(([term, description]: [string, any]) => [
                <dt className={styles.metaTerm} key="term">
                  {term}:
                </dt>,
                <dd className={styles.metaDescription} key="description">
                  {description}
                </dd>,
              ])}
          </dl>
        )}
      </div>

      <QuoteBase
        author={props.author}
        authorTitle={props.authorTitle}
        authorCompany={props.authorCompany}
        variant="Small"
        className={styles.quote}
      >
        {props.quote}
      </QuoteBase>
    </PageContentBlock>
  );
};
